import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { spacing, colors, radius, shadows, typePresets, focusVisible } from '@/styles/designTokens'

export const Overlay = styled('main')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '100vh',
	backgroundColor: colors.brand,
})

export const ScheduleCard = styled(Box)({
	maxWidth: 480,
	width: '100%',
	backgroundColor: colors.surfaceWhite,
	borderRadius: radius.card,
	boxShadow: shadows.modal,
	overflow: 'hidden',
})

export const CardContent = styled('div')({
	padding: spacing.xxl,
})

export const Heading = styled('h1')({
	...typePresets.headingXl,
	margin: 0,
	marginBottom: spacing.sm,
})

export const Message = styled('p')({
	...typePresets.bodyMd,
	margin: 0,
	color: colors.textSecondary,
})

export const Divider = styled('hr')({
	border: 'none',
	borderTop: `1px solid ${colors.divider}`,
	margin: 0,
})

export const CardFooter = styled('div')({
	display: 'flex',
	justifyContent: 'flex-end',
	padding: spacing.lg,
})

export const RefreshButton = styled('button')({
	...typePresets.labelMd,
	fontFamily: 'inherit',
	border: `1px solid ${colors.border}`,
	borderRadius: radius.badge,
	padding: `${spacing.xs}px ${spacing.lg}px`,
	backgroundColor: colors.surfaceWhite,
	color: colors.textPrimary,
	cursor: 'pointer',
	'&:hover': {
		backgroundColor: colors.overlaySubtle,
	},
	'&:focus-visible': {
		outline: `${focusVisible.outline} ${colors.overlayHeavy}`,
		outlineOffset: focusVisible.outlineOffset,
	},
})
